/* ==========================================================================
   EDEN BOITES - Paiement en plusieurs fois, interface maison

   N'utilise plus l'interface d'Alma : ni son badge, ni sa modale, ni son
   verrou de defilement. On interroge directement son API d'eligibilite et
   on affiche le resultat avec notre propre rendu.

   API : POST https://api.getalma.eu/v2/payments/eligibility
         Authorization: Alma-Merchant-Auth <merchant_id>

   ---------------------------------------------------------------------------
   DCC2 (en vigueur au 20/11/2026) : widget personnalise = mentions a notre
   charge, sur le badge ET dans la fenetre :
     1. TAEG, toujours affiche (meme 0,00 %)
     2. Phrase d'avertissement
     3. Exemple representatif du cout du credit
     4. Bloc legal Alma
   Source : docs.almapay.com/docs/dcc2-le-guide-technique-pas-a-pas
   --------------------------------------------------------------------------- */

var EDEN_ALMA_MERCHANT_ID = 'merchant_11iHYqSQEe64wEin2AUmg2eiyg686WJml1';

(function () {
  'use strict';

  var API = 'https://api.getalma.eu/v2/payments/eligibility';
  var PLANS = [4, 10];

  var state = { plans: [], current: 0, price: 0 };
  var badge = null;
  var overlay = null;

  /* --- textes reglementaires DCC2 (version anglaise fournie par Alma) ------------------------------ */

  var IT = (document.documentElement.lang || '').slice(0, 2) === 'it';
  var DE = (document.documentElement.lang || '').slice(0, 2) === 'de'; /* 30/10/2026 : version allemande (traduction des mentions EN/IT, à faire valider par Alma) */
  var ES = (document.documentElement.lang || '').slice(0, 2) === 'es'; /* 31/10/2026 : versions espagnole et portugaise (traduction des mentions EN/IT, à faire valider par Alma) */
  var PT = (document.documentElement.lang || '').slice(0, 2) === 'pt';
  var DCC2_AVERTISSEMENT = DE ? 'Achtung! Geld zu leihen kostet Geld.' : ES ? '¡Atención! Pedir dinero prestado cuesta dinero.' : PT ? 'Atenção! Pedir dinheiro emprestado custa dinheiro.' : IT ? 'Attenzione! Prendere denaro in prestito ha un costo.' : 'Caution! Borrowing money costs money.';
  var DCC2_LEGAL =
    DE ? 'Vorbehaltlich der Zustimmung von Alma SAS (almapay.com), von der ACPR zugelassenes Zahlungsinstitut (CIB: 17408). RCS Nanterre 839100575. Kontakt: support@almapay.com' :
    ES ? 'Sujeto a la aprobación de Alma SAS (almapay.com), entidad de pago autorizada por la ACPR (CIB: 17408). RCS Nanterre 839100575. Contacto: support@almapay.com' :
    PT ? 'Sujeito à aprovação da Alma SAS (almapay.com), instituição de pagamento autorizada pela ACPR (CIB: 17408). RCS Nanterre 839100575. Contacto: support@almapay.com' :
    IT ? 'Soggetto ad approvazione di Alma SAS (almapay.com), istituto di pagamento autorizzato dall’ACPR (CIB: 17408). RCS Nanterre 839100575. Contatto: support@almapay.com' :
    'Subject to approval by Alma SAS (almapay.com), payment institution authorised by the ACPR ' +
    '(CIB: 17408). RCS Nanterre 839100575. Contact: support@almapay.com';

  /* --- utilitaires ------------------------------------------------------ */

  var euro = new Intl.NumberFormat((DE ? 'de-DE' : ES ? 'es-ES' : PT ? 'pt-PT' : IT ? 'it-IT' : 'en-GB'), {
    style: 'currency',
    currency: 'EUR'
  });
  var jour = new Intl.DateTimeFormat((DE ? 'de-DE' : ES ? 'es-ES' : PT ? 'pt-PT' : IT ? 'it-IT' : 'en-GB'), {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  function money(cents) {
    return euro.format((cents || 0) / 100);
  }

  /* annual_interest_rate est en points de base : 2342 = 23,42 %.
     (L'ancienne version divisait par 10 000 et affichait 0,23 %.) */
  function pct(bps) {
    var s = ((bps || 0) / 100).toFixed(2); return (IT || DE || ES || PT) ? s.replace('.', ',') + ' %' : s + '%';
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function merchantId() {
    if (EDEN_ALMA_MERCHANT_ID && EDEN_ALMA_MERCHANT_ID !== 'REMPLACE_MOI') {
      return EDEN_ALMA_MERCHANT_ID;
    }
    /* Secours : le widget d'Alma expose l'identifiant dans la page */
    var m = document.documentElement.innerHTML.match(/merchant_[A-Za-z0-9]+/);
    return m ? m[0] : null;
  }

  /* --- mentions DCC2 ---------------------------------------------------- */

  /* Exemple representatif, formule imposee par Alma :
     [A] montant du credit = achat - part de capital de l'acompte
     [B] taux debiteur : 0 % jusqu'a 4x, TAEG au-dela
     [C] echeances restantes apres l'acompte
     [D] acompte = premiere echeance
     [E] frais client (mention retiree au-dela de 4x ou si sans frais)
     [F] montant de l'achat hors frais */
  function exemple(p) {
    var first = p.payment_plan[0];
    var capitalAcompte =
      first.total_amount - (first.customer_fee || 0) - (first.customer_interest || 0);
    var A = p.purchase_amount - capitalAcompte;
    var B = p.installments_count > 4 ? p.annual_interest_rate : 0;
    var C = p.installments_count - 1;
    var D = first.total_amount;
    var E = p.customer_total_cost_amount || 0;
    var F = p.purchase_amount;
    var frais = p.installments_count <= 4 && E > 0
      ? (DE ? ' (davon Gebühren: ' + money(E) + ')' : IT ? ' (di cui spese: ' + money(E) + ')' : ' which includes fees of ' + money(E))
      : '';
    return (
      (DE ? 'Ein Kredit über ' : ES ? 'Un préstamo de ' : PT ? 'Um empréstimo de ' : IT ? 'Un prestito di ' : 'A loan of ') + money(A) + (DE ? ' zu einem festen Sollzinssatz von ' : ES ? ' a un tipo deudor fijo del ' : PT ? ' a uma taxa devedora fixa de ' : IT ? ' a un tasso debitore fisso del ' : ' at a fixed borrowing rate of ') + pct(B) +
      (DE ? ' über ' : ES ? ' en ' : PT ? ' em ' : IT ? ' su ' : ' over ') + C + (DE ? ' Monate zur Finanzierung, zusätzlich zu einer Anzahlung von ' : ES ? ' meses financia, además de una entrada de ' : PT ? ' meses financia, além de uma entrada de ' : IT ? ' mesi, che finanzia, oltre a un acconto di ' : ' months. Financing, in addition to a ') + money(D) +
      (DE ? '' : ES ? '' : PT ? '' : IT ? '' : ' down payment') + frais + (DE ? ', eines Kaufs über ' : ES ? ', una compra de ' : PT ? ', uma compra de ' : IT ? ', un acquisto di ' : ', a purchase of ') + money(F) + '.'
    );
  }

  function blocDcc2(p) {
    return (
      '<div class="ea-dcc2">' +
      '<p class="ea-dcc2__warn">' + DCC2_AVERTISSEMENT + '</p>' +
      '<p class="ea-dcc2__ex">' + exemple(p) + '</p>' +
      '<p class="ea-dcc2__legal">' + DCC2_LEGAL + '</p>' +
      '</div>'
    );
  }

  /* --- donnees ---------------------------------------------------------- */

  function currentPrice() {
    return fetch(window.location.pathname.split('?')[0] + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var id = input ? parseInt(input.value, 10) : null;
        var v = product.variants.filter(function (x) {
          return x.id === id;
        })[0];
        return (v || product.variants[0]).price;
      });
  }

  function eligibility(amount) {
    var id = merchantId();
    if (!id) return Promise.reject(new Error('identifiant marchand introuvable'));

    return fetch(API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Alma-Merchant-Auth ' + id,
        'X-Alma-Agent': 'Eden Boites/1.0'
      },
      body: JSON.stringify({
        purchase_amount: amount,
        queries: PLANS.map(function (n) {
          return { installments_count: n, deferred_days: 0, deferred_months: 0 };
        })
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('API Alma ' + r.status);
      return r.json();
    });
  }

  /* --- rendu du badge --------------------------------------------------- */

  var LOGO =
    '<svg viewBox="0 0 352 120" class="ea-logo" aria-label="Alma">' +
    '<path fill="currentColor" d="M333.24 28.35v10.1c-5.74-7.35-14.06-11.93-23.95-11.93-19.08 0-33.87 17.03-33.87 38.06s14.79 38.06 33.87 38.06c10.58 0 19.38-5.25 25.13-13.51v11.69h19.25V28.35h-20.43Zm-19.21 56.14c-10.61 0-19.2-8.91-19.2-19.91s8.59-19.91 19.2-19.91 19.2 8.91 19.2 19.91-8.59 19.91-19.2 19.91ZM109.5 8.23h19.42v92.58H109.5V8.23Zm41.75 51.51c0-19.93 12.25-33.21 29.22-33.21 10.54 0 18.86 4.67 23.88 12.64 5.03-7.97 13.34-12.64 23.88-12.64 16.97 0 29.22 13.29 29.22 33.21v41.08h-19.42V57.64c0-7.78-5.16-12.85-11.99-12.85s-11.99 5.08-11.99 12.85v43.18h-19.42V57.64c0-7.78-5.16-12.85-11.99-12.85s-11.99 5.08-11.99 12.85v43.18h-19.42V59.74ZM74.34 29.1C69.74 11.91 60.02 6.41 50.77 6.41S31.8 11.91 27.2 29.1L7.25 100.83h19.67c3.2-11.98 13.08-18.66 23.85-18.66s20.65 6.69 23.86 18.66h19.68L74.34 29.1ZM50.77 65.46c-6.26 0-11.94 2.37-16.13 6.22l11.28-41.74c1.08-3.99 2.68-5.26 4.86-5.26s3.78 1.27 4.86 5.26l11.27 41.74c-4.19-3.85-9.88-6.22-16.14-6.22Z"/>' +
    '</svg>';

  function renderBadge() {
    if (!badge) return;
    var p = state.plans[state.current];
    if (!p) {
      badge.style.display = 'none';
      return;
    }
    badge.style.display = '';

    var first = p.payment_plan[0];
    var others = p.payment_plan[1] || first;
    var free = p.customer_total_cost_amount === 0;

    /* Avec frais, la premiere echeance est plus elevee que les suivantes :
       ecrire "4 x 807,75" serait faux, le total ne tomberait pas juste.
       On n'utilise cette forme que si toutes les echeances sont egales. */
    var egales = first.total_amount === others.total_amount;

    var montant = egales
      ? p.installments_count + ' &times; <strong>' + money(others.total_amount) + '</strong>'
      : '<strong>' + money(first.total_amount) + '</strong>' +
        '<span class="ea-then">' + (DE ? 'dann ' : ES ? 'y luego ' : PT ? 'depois ' : IT ? 'poi ' : 'then ') + (p.installments_count - 1) +
        ' &times; ' + money(others.total_amount) + '</span>';

    var total = p.purchase_amount + p.customer_total_cost_amount;
    var detail = free
      ? (DE ? 'Gesamt ' : ES ? 'Total ' : PT ? 'Total ' : IT ? 'Totale ' : 'Total ') + money(total)
      : (DE ? 'Gesamt ' : ES ? 'Total ' : PT ? 'Total ' : IT ? 'Totale ' : 'Total ') + money(total) + (DE ? ' &middot; davon ' : ES ? ' &middot; de ellos ' : PT ? ' &middot; dos quais ' : IT ? ' &middot; di cui ' : ' &middot; incl. ') +
        money(p.customer_total_cost_amount) + (DE ? ' Gebühren' : ES ? ' de gastos' : PT ? ' de encargos' : IT ? ' di spese' : ' in fees');
    detail += (DE ? ' &middot; Fester effektiver Jahreszins ' : ES ? ' &middot; TAE fija ' : PT ? ' &middot; TAEG fixa ' : IT ? ' &middot; TAEG fisso ' : ' &middot; Fixed APR ') + pct(p.annual_interest_rate);

    var opts = state.plans
      .map(function (plan, i) {
        return (
          '<button type="button" class="ea-opt' +
          (i === state.current ? ' is-on' : '') +
          '" data-i="' + i + '">' + plan.installments_count + 'x</button>'
        );
      })
      .join('');

    badge.innerHTML =
      '<div class="ea-badge__head">' +
      '<span class="ea-badge__eyebrow">' + (DE ? 'Ratenzahlung' : ES ? 'Pago a plazos' : PT ? 'Pagamento em prestações' : IT ? 'Pagamento rateale' : 'Pay in instalments') + '</span>' +
      LOGO +
      '</div>' +
      '<div class="ea-badge__opts">' + opts + '</div>' +
      '<p class="ea-badge__line">' + montant +
      (free ? '<span class="ea-free">' + (DE ? 'zinsfrei' : ES ? 'sin intereses' : PT ? 'sem juros' : IT ? 'senza interessi' : 'interest-free') + '</span>' : '') +
      '</p>' +
      '<p class="ea-sub">' + detail + '</p>' +
      blocDcc2(p) +
      '<button type="button" class="ea-more">' + (DE ? 'Zahlungsplan ansehen' : ES ? 'Ver el calendario de pagos' : PT ? 'Ver o plano de pagamentos' : IT ? 'Vedi il piano di pagamento' : 'View payment schedule') + ' &rarr;</button>';

    badge.querySelectorAll('.ea-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        state.current = parseInt(b.dataset.i, 10);
        renderBadge();
      });
    });
    badge.querySelector('.ea-more').addEventListener('click', openModal);
  }

  /* --- rendu de la fenetre ---------------------------------------------- */

  function renderModal() {
    var p = state.plans[state.current];
    if (!p) return;

    var lignes = p.payment_plan
      .map(function (inst, i) {
        var d = new Date(inst.due_date * 1000);
        return (
          '<li class="ea-inst' + (i === 0 ? ' is-first' : '') + '">' +
          '<span class="ea-dot"></span>' +
          '<span class="ea-when">' + (i === 0 ? (DE ? 'Heute' : ES ? 'Hoy' : PT ? 'Hoje' : IT ? 'Oggi' : 'Today') : jour.format(d)) + '</span>' +
          '<span class="ea-amt">' + money(inst.total_amount) + '</span>' +
          '</li>'
        );
      })
      .join('');

    var opts = state.plans
      .map(function (plan, i) {
        return (
          '<button type="button" class="ea-opt' +
          (i === state.current ? ' is-on' : '') +
          '" data-i="' + i + '">' + plan.installments_count + 'x</button>'
        );
      })
      .join('');

    var cout =
      (p.customer_total_cost_amount > 0
        ? '<p class="ea-cost"><span>' + (DE ? 'Davon Kreditkosten' : ES ? 'De ellos, coste del crédito' : PT ? 'Dos quais custo do crédito' : IT ? 'Di cui costo del credito' : 'Of which cost of credit') + '</span><span>' +
          money(p.customer_total_cost_amount) + '</span></p>'
        : '') +
      '<p class="ea-cost"><span>' + (DE ? 'Fester effektiver Jahreszins' : ES ? 'TAE fija' : PT ? 'TAEG fixa' : IT ? 'TAEG fisso' : 'Fixed APR') + '</span><span>' + pct(p.annual_interest_rate) + '</span></p>' +
      blocDcc2(p);

    overlay.querySelector('.ea-modal').innerHTML =
      '<button type="button" class="ea-close" aria-label="' + (DE ? 'Schließen' : ES ? 'Cerrar' : PT ? 'Fechar' : IT ? 'Chiudi' : 'Close') + '">&times;</button>' +
      '<div class="ea-left">' +
      '<h2 class="ea-title">' + (DE ? 'Bezahlen Sie in Raten mit Karte' : ES ? 'Pague a plazos con tarjeta' : PT ? 'Pague em prestações com cartão' : IT ? 'Pagate a rate con carta' : 'Pay in instalments by card') + '</h2>' +
      '<ol class="ea-steps">' +
      (DE ? '<li><span>1</span><p>Wählen Sie beim Bezahlen <strong>Alma</strong>.</p></li>' : ES ? '<li><span>1</span><p>Elija <strong>Alma</strong> en el momento del pago.</p></li>' : PT ? '<li><span>1</span><p>Escolha <strong>Alma</strong> no momento do pagamento.</p></li>' : IT ? '<li><span>1</span><p>Scegliete <strong>Alma</strong> al momento del pagamento.</p></li>' : '<li><span>1</span><p>Choose <strong>Alma</strong> at checkout.</p></li>') +
      (DE ? '<li><span>2</span><p>Folgen Sie den Schritten und bestätigen Sie in <strong>2 Minuten</strong>.</p></li>' : ES ? '<li><span>2</span><p>Siga los pasos y confirme en <strong>2 minutos</strong>.</p></li>' : PT ? '<li><span>2</span><p>Siga os passos e confirme em <strong>2 minutos</strong>.</p></li>' : IT ? '<li><span>2</span><p>Seguite le istruzioni e confermate in <strong>2 minuti</strong>.</p></li>' : '<li><span>2</span><p>Follow the steps and confirm in <strong>2 minutes</strong>.</p></li>') +
      (DE ? '<li><span>3</span><p><strong>Behalten Sie die Kontrolle</strong>, indem Sie Ihre Raten vorziehen oder verschieben.</p></li>' : ES ? '<li><span>3</span><p><strong>Mantenga el control</strong> adelantando o aplazando sus plazos.</p></li>' : PT ? '<li><span>3</span><p><strong>Mantenha o controlo</strong> antecipando ou adiando as suas prestações.</p></li>' : IT ? '<li><span>3</span><p><strong>Mantenete il controllo</strong> anticipando o posticipando le vostre rate.</p></li>' : '<li><span>3</span><p><strong>Stay in control</strong> by bringing forward or postponing your instalments.</p></li>') +
      '</ol>' + LOGO +
      '</div>' +
      '<div class="ea-right">' +
      '<div class="ea-badge__opts">' + opts + '</div>' +
      '<ul class="ea-schedule">' + lignes + '</ul>' +
      '<div class="ea-summary">' +
      '<p class="ea-total"><span>' + (DE ? 'Gesamt' : ES ? 'Total' : PT ? 'Total' : IT ? 'Totale' : 'Total') + '</span><span>' +
      money(p.purchase_amount + p.customer_total_cost_amount) + '</span></p>' +
      cout +
      '</div>' +
      '</div>';

    overlay.querySelectorAll('.ea-right .ea-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        state.current = parseInt(b.dataset.i, 10);
        renderModal();
        renderBadge();
      });
    });
    overlay.querySelector('.ea-close').addEventListener('click', closeModal);
  }

  /* --- ouverture / fermeture -------------------------------------------- */

  /* Bloque le defilement SANS modifier la moindre dimension de la page :
     on intercepte les evenements de defilement tant que la fenetre est
     ouverte. Le defilement interne de la fenetre reste possible. */

  var TOUCHES = {
    ArrowUp: 1, ArrowDown: 1, PageUp: 1, PageDown: 1, Home: 1, End: 1, ' ': 1
  };

  function bloque(e) {
    if (!overlay || !overlay.contains(e.target)) e.preventDefault();
  }

  function bloqueTouche(e) {
    if (!TOUCHES[e.key]) return;
    if (!overlay || !overlay.contains(document.activeElement)) e.preventDefault();
  }

  function lock() {
    document.addEventListener('wheel', bloque, { passive: false });
    document.addEventListener('touchmove', bloque, { passive: false });
    document.addEventListener('keydown', bloqueTouche, { passive: false });
  }

  function unlock() {
    document.removeEventListener('wheel', bloque, { passive: false });
    document.removeEventListener('touchmove', bloque, { passive: false });
    document.removeEventListener('keydown', bloqueTouche, { passive: false });
  }

  function openModal() {
    if (!overlay) {
      overlay = el('div', 'ea-overlay');
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.appendChild(el('div', 'ea-modal'));
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
      document.body.appendChild(overlay);
    }
    renderModal();
    lock();
    overlay.classList.add('is-open');
  }

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    unlock();
  }

  /* --- insertion et demarrage ------------------------------------------- */

  function anchor() {
    /* Ancrage deterministe sur #alma-widget (rendu cote serveur), le
       formulaire panier ne sert que de secours ultime. */
    return (
      document.querySelector('#alma-widget') ||
      document.querySelector('.alma_widget_block') ||
      document.querySelector('.alma-payment-plans-container') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function load(retries) {
    currentPrice()
      .then(function (price) {
        state.price = price;
        return eligibility(price);
      })
      .then(function (plans) {
        state.plans = plans.filter(function (p) {
          return p.eligible;
        });
        state.current = 0;
        renderBadge();
      })
      .catch(function (err) {
        if (retries > 0) {
          setTimeout(function () {
            load(retries - 1);
          }, 700);
          return;
        }
        console.warn('[eden-alma]', err.message);
        if (badge) badge.remove();
      });
  }

  function start() {
    var host = anchor();
    if (!host) return;

    badge = el('div', 'ea-badge');
    badge.style.display = 'none';
    host.parentNode.insertBefore(badge, host.nextSibling);
    document.documentElement.classList.add('eden-alma-ready');

    load(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
